module.exports = __webpack_public_path__ + "static/media/transport.e8623cb8.png";